module.exports = __webpack_public_path__ + "static/media/icon_comment-1on1-color.590157cd.svg";